import {useCallback, useEffect, useRef} from "react";
import {useLocation, useNavigate} from "react-router-dom";

const BackLink = ({ children, className }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const pathHistory = useRef([]);

    useEffect(() => {
        // if (!pathHistory.current.includes(location.pathname)) {
        //     pathHistory.current.push(location.pathname);
        // }
        if (!pathHistory.current.includes(location.pathname) && !location.state?.fromRedirect) {
            pathHistory.current.push(location.pathname);
        }
    }, [location.pathname]);

    const handleBackClick = useCallback(() => {
        if (pathHistory.current.length > 0) {
            pathHistory.current.pop();
        }

        if (pathHistory.current.length > 0) {
            const previousPath = pathHistory.current[pathHistory.current.length - 1];
            navigate(previousPath, { replace: true });
        } else {
            navigate(-1);
        }
    }, [navigate]);

    return (
        <a className={className} onClick={handleBackClick} href="#">
            {children}
        </a>
    );
};

export default BackLink;